import * as React from "react";
import Card from "@mui/material/Card";
import "../../../../theme.css";
import "./StaysCard.css";
// import ReactReadMoreReadLess from 'react-read-more-read-less'
import ReactMoreReadLess from "../../../common/ReadMoreReadLess/ReactMoreReadLess";
import { v4 } from "uuid";
import {
  // checkNull,
  // checkUndefined,
  ChipTitle,
  dateDDMM,
  dateRangeFormat,
  getImageUrlFromName,
} from "../../../../util";
// import getCurrencySymbol from 'currency-symbol-map'
import guest from "../../../../assets/images/guest.svg";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";
import { fetchCurrentState } from "../../../../redux/features/customerViewSlice";
import { stayViewModel } from "../../customerViewDataModel";
import confirmed_icon from "../../../../assets/images/icons/confirmed_icon.svg";
import calender_icon from "../../../../assets/images/icons/calender_icon.svg";
import booking_icon from "../../../../assets/images/icons/booking_icon.svg";
import { useNavigate } from "react-router-dom";
import SuggestedStays from "./SuggestedStays";
import nostay from "../../../../assets/images/no-stay.svg";
import ChipTag from "../../../common/ChipTag";
import TextTruncate from "react-text-truncate";
import { useEffect } from "react";
import {
  analyticsEvent,
  eventName,
} from "../../../common/Analytics/AnalyticsEvent";
import { NumericFormat } from "react-number-format";

function StaysCard(props) {
  console.log(">>>>>:: Stays Rendered");

  useEffect(() => {
    return () => {
      console.log("Stays >>> :: Unmounted");
    };
  }, []);

  // console.log(props.data.itinerary_items[0].item_type)

  const navigate = useNavigate();

  // const tripStateData = useSelector(fetchCurrentState)
  const tripStateData = props.tripStateData;

  const stayObjArr = stayViewModel(tripStateData.trip_days);

  console.log(stayObjArr);

  return (
    <div>
      {stayObjArr.map((stay, index) => {
        // console.log(stay.booking_info.booking_status)
        return (
          <div key={v4()} style={{ marginBottom: "40px" }}>
            {!isEmpty(stay.stayDetail) ? (
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    lineHeight: "0px",
                    height: "21px",
                  }}
                >
                  <p
                    className="headline1 truncated"
                    style={{ lineHeight: "22.5px" }}
                  >
                    {stay.place_title}
                  </p>
                  {/* <TextTruncate
                    line={1}
                    element="p"
                    truncateText="…"
                    text={stay.place_title}
                    containerClassName="headline1"
                    style={{
                      color: 'var(--gray100)',
                      lineHeight: '22.5px',
                    }}
                  /> */}

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img
                      src={calender_icon}
                      style={{ marginRight: "5px" }}
                      alt="calender"
                    ></img>

                    <p className="headline1">
                      {stay.date.length > 1
                        ? !isEmpty(stay.date[0]) &&
                          !isEmpty(stay.date[stay.date.length - 1])
                          ? dateRangeFormat(
                              stay.date[0],
                              stay.date[stay.date.length - 1]
                            )
                          : "Day: " +
                            stay.day[0] +
                            "-" +
                            stay.day[stay.day.length - 1]
                        : !isEmpty(stay.date[0])
                        ? dateDDMM(stay.date[0])
                        : "Day: " + stay.day[0]}
                    </p>
                  </div>
                </div>

                <Card
                  sx={{
                    maxWidth: "100%",
                    margin: "16px 0px ",
                    borderRadius: "8px",
                    paddingBottom: "16px",
                    border: "none",
                    boxShadow: "2px 4px 24px rgba(11, 12, 21, 0.1)",
                  }}
                  variant="outlined"
                >
                  <div className="inner-layer-stay">
                    <div
                      style={{
                        display: "flex",
                        lineHeight: "15px",
                        margin: "0px 0px 16px",
                        // justifyContent: "space-around",
                        // alignItems: "center",
                        // margin: '0px 15px 15px 15px',
                      }}
                    >
                      <div
                        className="stop-image-item"
                        style={{
                          width: "30%",
                          minWidth: "100px",
                          minHeight: "82px",
                          marginRight: "15px",
                          position: "relative",
                        }}
                        onClick={() => {
                          props.handleDetailPageOpen(
                            stay.stayDetail.item_id,
                            stay.stayDetail.is_default
                          );
                          analyticsEvent.clickEvent(
                            "Stays",
                            eventName.Stays_view_item_details,
                            `item_id: ${stay.stayDetail.item_id}, item_type: ${stay.stayDetail.item_type}, item_name: ${stay.stayDetail.place_title}, item_city: ${stay.stayDetail.city}`
                          );
                        }}
                      >
                        <img
                          style={{
                            borderRadius: "8px",
                            width: "100%",
                            // height: '70%',
                            alignSelf: "baseline",
                            marginTop: "15px",
                            cursor: "pointer",
                            aspectRatio: "6/5",
                          }}
                          alt="stop"
                          src={stay.stayDetail.image}
                        ></img>
                        <div
                          style={{
                            position: "absolute",
                            left: "4px",
                            top: "20px",
                            zIndex: 2,
                          }}
                        >
                          <ChipTag
                            tagInfo={{
                              label:
                                ChipTitle[stay.stayDetail.item_type] +
                                " " +
                                (index + 1),
                              bgColor: "white",
                              item_type: stay.stayDetail.item_type,
                            }}
                          />
                        </div>
                      </div>
                      <div
                        className="stay-details-item"
                        style={{ marginTop: "8px", width: "80%" }}
                      >
                        <div
                          onClick={() => {
                            props.handleDetailPageOpen(
                              stay.stayDetail.item_id,
                              stay.stayDetail.is_default
                            );
                            analyticsEvent.clickEvent(
                              "Stays",
                              eventName.Stays_view_item_details,
                              `item_id: ${stay.stayDetail.item_id}, item_type: ${stay.stayDetail.item_type}, item_name: ${stay.stayDetail.place_title}, item_city: ${stay.stayDetail.city}`
                            );
                          }}
                        >
                          {stay.stayDetail.booking_status ===
                            "BOOKING_CONFIRMED" && (
                            <div style={{}}>
                              <p
                                className="body3"
                                style={{ color: "var(--statusSeaweedGreen)" }}
                              >
                                <span
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <img
                                    src={confirmed_icon}
                                    style={{ marginRight: "3px" }}
                                    alt="confirmed"
                                  ></img>
                                  Booking Confirmed
                                </span>
                              </p>
                            </div>
                          )}
                          {/* <p
                          className="headline2"
                          style={
                            stay.stayDetail.booking_status ===
                            'BOOKING_CONFIRMED'
                              ? {
                                  marginTop: '0px',
                                  cursor: 'pointer',
                                  lineHeight: '25px',
                                }
                              : { cursor: 'pointer', lineHeight: '22.5px' }
                          }
                        >
                          {stay.stayDetail.place_title}
                        </p> */}
                          <TextTruncate
                            line={2}
                            element="p"
                            truncateText="…"
                            text={stay.stayDetail.place_title}
                            // text="Lorem Ipsum is simply dummy text of the printing and type..."
                            containerClassName="headline2"
                            style={
                              stay.stayDetail.booking_status ===
                              "BOOKING_CONFIRMED"
                                ? {
                                    marginTop: "0px",
                                    cursor: "pointer",
                                    lineHeight: "22.5px",
                                  }
                                : { cursor: "pointer", lineHeight: "22.5px" }
                            }
                          />
                          <p
                            className="body4"
                            style={{
                              color: "var(--gray80)",
                            }}
                          >
                            {stay.stayDetail.rating && (
                              <span>
                                {stay.stayDetail.rating}
                                &nbsp;&#x2022;&nbsp;
                              </span>
                            )}
                            <span>
                              {stay.date.length > 1
                                ? !isEmpty(stay.date[0]) &&
                                  !isEmpty(stay.date[stay.date.length - 1])
                                  ? dateRangeFormat(
                                      stay.date[0],
                                      stay.date[stay.date.length - 1]
                                    )
                                  : "Day: " +
                                    stay.day[0] +
                                    "-" +
                                    stay.day[stay.day.length - 1]
                                : !isEmpty(stay.date[0])
                                ? dateDDMM(stay.date[0])
                                : "Day: " + stay.day[0]}
                            </span>
                            {stay.stayDetail.total_guest && (
                              <span>
                                {" "}
                                &#x2022;&nbsp;
                                <img
                                  src={guest}
                                  style={{
                                    width: "12px",
                                    height: "auto",
                                    display: "inline",
                                  }}
                                  alt="guest"
                                ></img>
                                &nbsp;{stay.stayDetail.total_guest}
                              </span>
                            )}
                          </p>
                          {stay.stayDetail.price && (
                            <p
                              className="body3"
                              style={{
                                marginBottom: "0px",
                              }}
                            >
                              {/* {stay.stayDetail.price} */}
                              {}
                              <NumericFormat
                                value={stay.stayDetail.price}
                                thousandsGroupStyle="lakh"
                                thousandSeparator=","
                                displayType="text"
                                renderText={(value) => (
                                  <span style={{ color: "var(--gray80)" }}>
                                    {stay.stayDetail.currency + value}
                                  </span>
                                )}
                              />
                              <span
                                className="body3"
                                style={{ color: "var(--gray60)" }}
                              >
                                {" "}
                                / night
                              </span>
                            </p>
                          )}
                        </div>
                        <div
                          style={{
                            display: "flex",
                          }}
                        >
                          {stay.stayDetail.booking_status ===
                            "BOOKING_CONFIRMED" && (
                            <div style={{ display: "flex" }}>
                              <img
                                src={booking_icon}
                                style={{ marginRight: "5px" }}
                                alt="booking_icon"
                              ></img>
                              <p
                                className="headline2"
                                style={{ color: "var(--primaryShades20)" }}
                              >
                                View Booking
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    {stay.stayDetail.notes.map((note) => {
                      let iconURL = getImageUrlFromName(note.icon_name);
                      // console.log('>>>>>iconURL:: ', iconURL)
                      return (
                        !isEmpty(note.value) && (
                          <div className="notes-div-stay" key={v4()}>
                            <div style={{ display: "inline-flex" }}>
                              <span>
                                <img
                                  src={iconURL}
                                  alt=""
                                  className="notes-icon"
                                  style={{
                                    width: "20px",
                                    height: "auto",
                                    marginTop: "5px",
                                  }}
                                ></img>
                              </span>
                              <p
                                className="body3 notes-para"
                                style={{ color: "var(--gray100)" }}
                              >
                                {/* <ReactReadMoreReadLess
                                  charLimit={70}
                                  readMoreText={'Read more ˅'}
                                  readLessText={'Read less ˄'}
                                  readMoreStyle={{
                                    color: '#00857D',
                                    cursor: 'pointer',
                                  }}
                                  readLessStyle={{
                                    color: '#00857D',
                                    cursor: 'pointer',
                                  }}
                                >
                                  {note.value}
                                </ReactReadMoreReadLess> */}
                                <ReactMoreReadLess
                                  moreText={"Read more"}
                                  lessText={"Read less"}
                                  showArrow={true}
                                  top={"5px"}
                                  lines={"3"}
                                  analytics={true}
                                  analyticsProps={{
                                    page: "Stays",
                                    eventName: eventName.Stays_note_expanded,
                                  }}
                                >
                                  {note.value}
                                </ReactMoreReadLess>
                              </p>
                            </div>
                          </div>
                        )
                      );
                    })}
                  </div>
                  {!isEmpty(stay.stayDetail.suggestion_stays) && (
                    <div style={{ position: "relative" }}>
                      <SuggestedStays
                        items={stay.stayDetail.suggestion_stays}
                        handleDetailPageOpen={props.handleDetailPageOpen}
                      ></SuggestedStays>
                    </div>
                  )}
                </Card>
              </div>
            ) : (
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    lineHeight: "0px",
                  }}
                >
                  <p className="headline1">{stay.place_title}</p>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img
                      src={calender_icon}
                      style={{ marginRight: "5px" }}
                      alt="calender"
                    ></img>
                    <p className="headline1">{dateDDMM(stay.date)}</p>
                  </div>
                </div>
                <Card
                  sx={{
                    marginBottom: "16px",
                    marginTop: "7px",
                    borderRadius: "8px",
                    border: "none",
                    boxShadow: "2px 4px 24px rgba(11, 12, 21, 0.1)",
                  }}
                  variant="outlined"
                >
                  <div style={{ display: "flex", padding: "15px" }}>
                    <img
                      src={nostay}
                      alt="no-stay"
                      style={{
                        background: "var(--gray5)",
                        borderRadius: "8px",
                        minWidth: "100px",
                        minHeight: "82px",
                      }}
                    ></img>
                    <p
                      className="headline2"
                      style={{
                        margin: "0px 0px 0px 16px",
                        color: "var(--gray100)",
                      }}
                    >
                      No stay options added as yet
                    </p>
                  </div>
                </Card>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default StaysCard;
export const MemoizedStayCard = React.memo(StaysCard);
